import Text11 from './Text11'
export default Text11
